import { Injectable } from '@nestjs/common';
import { Repository } from 'typeorm';
import { EmploymentStatus } from './employment-status.entity';
import { EmploymentStatDTO } from './dto/employment-status.dto';
import { InjectRepository } from '@nestjs/typeorm';
import { EmployStatAdapter } from './dto/employment-status.adapter';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { EmploymentStatRequest } from './dto/employment-status.request';
import { EmploymentStatusEnum } from './employment-status.enum';
import { AllEmploymentStatusResponse, EmploymentStatusResponse } from '@gtpl/shared-models/hrms';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class EmploymentStatusService {
    constructor(
      private logService:LogsService,
        @InjectRepository(EmploymentStatus)
        private employStatRepo: Repository<EmploymentStatus>,
        private employStatAdapter: EmployStatAdapter,
    ) { }

    async getEmploymentStatDetailsWithoutRelations(employmentStat: string): Promise<EmploymentStatus> {
        const response = await this.employStatRepo.findOne({
            where: { employmentStatus: employmentStat },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createEmploymentStatus(employStatDto: EmploymentStatDTO, isUpdate: boolean): Promise<EmploymentStatusResponse> {
        if (!isUpdate) {
            const employStatEnity = await this.getEmploymentStatDetailsWithoutRelations(employStatDto.employmentStatus);
            if (employStatEnity) {
                throw new ErrorResponse(11104, 'Employment Status Already Exists');
            }
        } else {
            const employStatEnity = await this.getEmploymentStatDetailsWithoutRelations(employStatDto.employmentStatus);
            if (employStatEnity) {
                if (employStatEnity.employmentStatusId != employStatDto.employmentStatusId) {
                    throw new ErrorResponse(11104, 'Employment Status Already Exists');
                }
            }
        }
        const convertedEntity: EmploymentStatus = this.employStatAdapter.convertDtoToEntity(employStatDto);
        const savedEntity: EmploymentStatus = await this.employStatRepo.save(convertedEntity);
        const savedDto: EmploymentStatDTO = this.employStatAdapter.convertEntityToDto(convertedEntity);
        if (savedDto) {
            const response = new EmploymentStatusResponse(true, 1, isUpdate ? 'Employment Status Updated Successfully' : 'Employment Status Created Successfully');
            const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'EmploymentStatus', savedDto.employmentStatusId, true, '',savedDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
        } else {
            throw new ErrorResponse(11106, 'Employment Status is saved but there must have been an issue while transforming it into DTO');
        }
    }

    async getAllEmploymentStats(): Promise<AllEmploymentStatusResponse> {
        try {
            const employStatDtos: EmploymentStatDTO[] = [];
            const employStatEntities: EmploymentStatus[] = await this.employStatRepo.find({ order: { createdAt: 'DESC' } });
            if (employStatEntities) {
                employStatEntities.forEach(entity => {
                    const convertedEntity: EmploymentStatDTO = this.employStatAdapter.convertEntityToDto(entity);
                    employStatDtos.push(convertedEntity);
                });
                const response = new AllEmploymentStatusResponse(true, 1, 'Employment Stats Retrieved Succeffully', employStatDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAllActiveEmployStats(): Promise<AllEmploymentStatusResponse> {
        try {
            const employStatDtos: EmploymentStatDTO[] = [];
            const employStatEntities: EmploymentStatus[] = await this.employStatRepo.find({ order: { employmentStatus: 'ASC' }, where: { isActive: true }, });
            if (employStatEntities) {
                employStatEntities.forEach(entity => {
                    const convertedEntity: EmploymentStatDTO = this.employStatAdapter.convertEntityToDto(entity);
                    employStatDtos.push(convertedEntity);
                });
                const response = new AllEmploymentStatusResponse(true, 1, 'Employment Stats Retrieved Succeffully', employStatDtos);
                const newLogDto = new LogsDto(1,'view', 'EmploymentStatus', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getEmploymentStatusById(id: number): Promise<EmploymentStatus> {
        const response = await this.employStatRepo.findOne({
            where: { employmentStatusId: id },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateEmployStatus(req: EmploymentStatRequest): Promise<EmploymentStatusResponse> {
        try {
            const statExists = await this.getEmploymentStatusById(req.employmentStatusId);
            if (statExists) {
                if (req.versionFlag != statExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current employment status information. Refresh and try again');
                } else {
                    const empStat = await this.employStatRepo.update(
                        { employmentStatusId: req.employmentStatusId },
                        { isActive: req.isActive, updatedUser: req.updatedUser }
                    );
                    if (statExists.isActive) {
                        if (empStat.affected) {
                            const response: EmploymentStatusResponse = new EmploymentStatusResponse(true, 10115, 'Employment Status is de-activated successfully');
                            return response;
                        } else {
                            throw new ErrorResponse(10111, 'Employment status is already de-activated');
                        }
                    } else {
                        if (empStat.affected) {
                            const response: EmploymentStatusResponse = new EmploymentStatusResponse(true, 10114, 'Employment status is activated successfully');
                            return response;
                        } else {
                            throw new ErrorResponse(10112, 'Employment status is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
}
